import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

export default function NotFoundPage() {
  return (
    <section className="container-narrow min-h-[60vh] flex items-center justify-center py-20">
      <div className="text-center max-w-md">
        <div className="text-[11px] uppercase tracking-[0.22em] text-terracotta font-semibold">404</div>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl text-ink leading-tight">
          This page is taking a quiet moment.
        </h1>
        <p className="mt-4 text-ink-muted leading-[1.75]">
          The page you're looking for doesn't exist (yet). Let's head home.
        </p>
        <div className="mt-6">
          <Link to="/">
            <Button data-testid="notfound-home-button" className="bg-[#C86A4A] hover:bg-[#B85F41] text-white rounded-xl">
              <Home className="w-4 h-4 mr-2" /> Back to home
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
